import { get } from './apiClient';

export function searchCities(query) {
  return get(`/cities?q=${encodeURIComponent(query)}`).then((data) => data.results);
}